import { Navigate } from "react-router-dom";

export default function FeatureGuard({ enabled, redirect = "/overview", children }) {
  if (enabled === null) {
    return null; // or a loader
  }

  if (!enabled) {
    return <Navigate to={redirect} replace />;
  }

  return children;
}